module.exports = __webpack_public_path__ + "img/androidMock.8edd31.png";